import Animation from 'src/components/common/animation/index.js';
import { Button, Icon, UncontrolledTooltip } from '@polichat/flamboyant';
import { StarsIcon } from './star-icon';
interface TranscriptionButtonProps {
  isLoading: boolean;
  error: boolean;
  canTryAgain: boolean;
  handleTranscription: () => void;
  isEnabled: boolean;
}

const DISABLED_MESSAGE =
  'Funcionalidade indisponível. Converse com a nossa equipe para liberar agora mesmo!';

export function TranscriptionButton({
  isLoading,
  error,
  canTryAgain,
  handleTranscription,
  isEnabled,
}: TranscriptionButtonProps) {
  const isDarkMode = JSON.parse(
    localStorage.getItem('@polichat/darkmode') || 'false'
  );
  if (isLoading) {
    return (
      <div
        style={{
          width: '44px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Animation icon="loading" size="minorLittleTiny" />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          width: '34px',
          display: 'flex',
          alignItems: 'center',
          padding: '0 0.25rem',
        }}
      >
        <Button
          color="danger"
          size="sm"
          disabled={!canTryAgain}
          style={{ padding: '0 0.25rem' }}
          onClick={handleTranscription}
        >
          <Icon icon={'poli-icon pi-update-fill'} size={18} />
        </Button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Button
        id="transcription-button"
        color="transparent"
        size="sm"
        disabled={!canTryAgain || !isEnabled}
        onClick={handleTranscription}
        style={{
          padding: '0 0.25rem',
          cursor: isEnabled ? 'pointer' : 'not-allowed',
        }}
      >
        {!isEnabled ? (
          <UncontrolledTooltip placement="bottom" target="transcription-button">
            {DISABLED_MESSAGE}
          </UncontrolledTooltip>
        ) : (
          <UncontrolledTooltip placement="bottom" target="transcription-button">
            {'Transcrever'}
          </UncontrolledTooltip>
        )}
        <StarsIcon
          id="transcription-icon"
          fill={isDarkMode ? 'white' : 'black'}
          height={16}
          width={24}
          alt="Transcrever"
        />
      </Button>
    </div>
  );
}
